import classNames from 'classnames'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { stringify } from 'querystring'
import SubNav from './sub-nav'
import formatTime from 'lib/format-time'
import Button from 'Components/button'
import Modal from 'Components/modal'
import Publisher, { IPB } from 'Components/publisher/publisher'
import { CloseIconForPublisher } from 'Components/publisher/close-icon'
import { useRouter } from 'next/router'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import Link from 'next/link'
import fetch from 'lib/decorated-fetch'
import useLoginCheckCallback from 'Components/hooks/use-login-check-callback'
const show_more_icon = require('static/show-more.png')
const replace_img = require('static/selected-dafault.png')
interface RepostInfo {
  title: string
  image_url: string
  item_id_str: number
  behot_time: number
  comment_count: number
  is_pgc_article?: 0 | 1
}

interface ICommunity {
  series_id: string
  series_name: string
  motor_id: number
}

export default function Community(props: ICommunity) {
  const { series_id, series_name = '当前车友圈', motor_id } = props
  const router = useRouter()
  const [tabNow, setTabNow] = useState('selected')
  const [selectedReposts, setSelectedReposts] = useState<RepostInfo[]>([])
  const [qaReposts, setQAReposts] = useState<RepostInfo[]>([])
  const [showPublisher, setShowPublisher] = useState(false)
  const handleClick = useCallback((payload) => {
    setTabNow(payload)
  }, [])
  useEffect(() => {
    const fetchData = async () => {
      const query = {
        series_id,
      }
      const json = await fetch(
        `/motor/m_api/pc_hot_community_content?${stringify(query)}`
      ).catch((e) => {
        // no-op
      })
      setSelectedReposts(
        json?.data?.list?.map((item: any) => ({
          ...item.info?.repost_info,
          is_pgc_article: item.is_pgc_article,
        })) || []
      )
    }
    try {
      fetchData()
    } catch (err) {
      console.error(err)
    }
  }, [])
  useEffect(() => {
    const fetchData = async () => {
      const query = {
        series_id,
        type: 'cheyou_wenda',
      }
      const json = await fetch(
        `/motor/m_api/pc_series_community_content?${stringify(query)}`
      ).catch((e) => {
        // no-op
      })
      setQAReposts(
        json?.data?.map((item: any) => ({
          ...item.info?.repost_info,
          behot_time: item.info?.behot_time,
          comment_count: item.info?.comment_count,
        })) || []
      )
    }
    try {
      fetchData()
    } catch (err) {
      console.error(err)
    }
  }, [])
  const handleTogglePublisher = useLoginCheckCallback(
    useCallback(() => {
      sendTeaCommEvent('click_series_forum_publish', {
        car_series_id: series_id,
        motor_id,
      })
      setShowPublisher(!showPublisher)
    }, [showPublisher]),
    useMemo(() => {
      return {
        enter_method: 'publish',
      }
    }, [])
  )

  const handlePublish = async (props: IPB) => {
    const { isTimer } = props

    if (!isTimer) {
      router.push(`/community/${series_id}`)
    }

    setShowPublisher(false)
  }
  const reposts = useMemo(() => {
    if (tabNow === 'selected') {
      return selectedReposts
    } else {
      return qaReposts
    }
  }, [tabNow, selectedReposts, qaReposts])

  const tabs = useMemo(() => {
    const tabs = []
    if (selectedReposts.length > 0) {
      tabs.push({
        text: '热门',
        value: 'selected',
      })
    }
    if (qaReposts.length > 0) {
      tabs.push({
        text: '问答',
        value: 'qa',
      })
    }
    setTabNow(tabs[0]?.value || '')
    return tabs
  }, [selectedReposts, qaReposts])
  return (
    <div className="community">
      <span className="head">车友圈</span>
      <SubNav tabs={tabs} align="right" onClick={handleClick} tabNow={tabNow} />
      {tabs.length > 0 ? (
        <div className="content">
          {tabNow === 'selected' ? (
            <>
              <div className="covers">
                {reposts.slice(0, 2).map((repost: any, index: number) => {
                  const {
                    title,
                    image_url,
                    item_id_str: item_id = 0,
                    is_pgc_article,
                  } = repost || {}
                  return (
                    <span
                      className="cover"
                      key={item_id}
                      onClick={() => {
                        sendTeaCommEvent('click_series_forum_pic', {
                          sub_tab: '热门',
                          car_series_id: series_id,
                          motor_id,
                          group_id: item_id,
                        })
                      }}
                    >
                      <a
                        href={`${
                          is_pgc_article === 1 ? '' : '/ugc'
                        }/article/${item_id}`}
                        // eslint-disable-next-line react/jsx-no-target-blank
                        target="_blank"
                      >
                        <img src={image_url || replace_img} className="zoom" />
                      </a>

                      <a
                        href={`/ugc/article/${item_id}`}
                        // eslint-disable-next-line react/jsx-no-target-blank
                        target="_blank"
                      >
                        <span className="line-1">{title}</span>
                      </a>
                    </span>
                  )
                })}
              </div>

              <div className="titles">
                {reposts.slice(2, 10).map((repost, index) => {
                  const {
                    title,
                    image_url,
                    item_id_str: item_id,
                    is_pgc_article,
                  } = repost
                  return (
                    <span className="title line-1" key={item_id}>
                      <a
                        href={`${
                          is_pgc_article === 1 ? '' : '/ugc'
                        }/article/${item_id}`}
                        // eslint-disable-next-line react/jsx-no-target-blank
                        target="_blank"
                        onClick={() => {
                          sendTeaCommEvent('click_series_forum_group', {
                            sub_tab: '热门',
                            car_series_id: series_id,
                            motor_id,
                            group_id: item_id,
                            rank: index,
                          })
                        }}
                      >
                        {title}
                      </a>
                    </span>
                  )
                })}
              </div>
            </>
          ) : (
            <>
              {qaReposts.slice(0, 3).map((item, index) => (
                <a
                  href={`/ugc/article/${item.item_id_str}`}
                  // eslint-disable-next-line react/jsx-no-target-blank
                  target="_blank"
                  key={item.item_id_str}
                  style={{ width: '100%' }}
                  onClick={() => {
                    sendTeaCommEvent('click_series_forum_qa', {
                      sub_tab: '问答',
                      car_series_id: series_id,
                      motor_id,
                      group_id: item.item_id_str,
                      rank: index,
                    })
                  }}
                >
                  <div className="qa-item" key={item.item_id_str}>
                    <p className="qa-title">{item.title}</p>
                    <span className="time">
                      {formatTime(item.behot_time * 1000)}
                    </span>
                    <span className="comment-count">
                      {item.comment_count}个回答
                    </span>
                  </div>
                </a>
              ))}
              {qaReposts.length > 0 && (
                <Link href={`/auto/series/${series_id}/${tabNow}`}>
                  <span
                    className="show-more"
                    onClick={(eve) => {
                      sendTeaCommEvent('click_series_forum_qa_more', {
                        car_series_id: series_id,
                        motor_id,
                        sub_tab: '问答',
                      })
                    }}
                  >
                    查看更多问答
                    <img src={show_more_icon} />
                  </span>
                </Link>
              )}
            </>
          )}
        </div>
      ) : (
        <>
          <div className="no-data">
            <span>暂无热门内容和问答</span>
            <Button
              type="new_primary"
              className="publish-button"
              onClick={handleTogglePublisher}
            >
              <span className="publish-button-text">发布</span>
            </Button>
          </div>

          <Modal
            visible={showPublisher}
            onClose={handleTogglePublisher}
            className="publisher-modal"
            closable={true}
            CloseIcon={CloseIconForPublisher}
          >
            <Publisher
              onPublish={handlePublish}
              defaultCommunity={{
                series_name,
                series_id,
              }}
            />
          </Modal>
        </>
      )}

      <style jsx>
        {`
          .community {
            width: 320px;
            height: 290px;
            padding: 16px;
            background-color: white;
            position: relative;
          }
          .head {
            position: absolute;
            top: 16px;
            left: 16px;
            font-family: PingFangSC-Medium;
            font-size: 18px;
            color: #1f2129;
            letter-spacing: 0;
            font-weight: 500;
          }
          .content {
            margin-top: ${tabNow === 'selected' ? '13px' : '0'};
            display: flex;
            align-items: flex-start;
            min-width: 0;
            /* The initial setting on flex items is min-width: auto. So, in order for each item to stay within the container, we need to give min-width: 0. */
            flex-wrap: nowrap;
            flex-direction: ${tabNow === 'selected' ? 'row' : 'column'};
            height: 198px;
          }
          .covers {
            display: inline-flex;
            width: 101px;
            flex-direction: column;
            align-items: stretch;
            margin-right: 16px;
            vertical-align: top;
          }
          .cover {
            margin-bottom: 16px;
            border-radius: 2px;
            overflow: hidden;
            width: 101px;
            height: 91px;
            position: relative;
          }
          .cover:last-child {
            margin-bottom: 0;
          }

          .cover img {
            object-fit: cover;
            object-position: center;
            width: 100%;
            height: 100%;
          }
          .cover span {
            position: absolute;
            left: 0;
            bottom: 0;
            background-image: linear-gradient(
              180deg,
              rgba(0, 0, 0, 0) 0%,
              rgba(0, 0, 0, 0.8) 100%
            );
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: rgba(255, 255, 255, 0.9);
            letter-spacing: 0;
            line-height: 18px;
            font-weight: 400;
            height: 33px;
            width: 100%;
            padding: 9px 9px 6px 8px;

            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .cover:hover span {
            color: #ffcc32;
          }
          .titles {
            display: inline-flex;
            flex-direction: column;
            align-items: stretch;
            height: 100%;
            min-width: 0;
            /* The initial setting on flex items is min-width: auto. So, in order for each item to stay within the container, we need to give min-width: 0. */
          }
          .title {
            margin-bottom: 6px;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #1f2129;
            letter-spacing: 0;
            font-weight: 400;
            cursor: pointer;
          }
          .title:hover {
            color: #e62021;
          }
          .title:nth-child(4) {
            margin-bottom: 9px;
          }
          .title:last-child {
            margin-bottom: 0;
          }
          .qa-item {
            height: 64px;
            border-bottom: 1px solid #f2f4fa;
            padding: 8px 0;
            position: relative;
            width: 100%;
            flex: 0 0 auto;
          }
          .qa-title {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-family: PingFangSC-Medium;
            font-size: 14px;
            color: #1f2129;
            letter-spacing: 0;
            line-height: 21px;
            font-weight: 500;
            cursor: pointer;
          }
          .qa-title:hover {
            color: #e62021;
          }
          .time {
            position: absolute;
            bottom: 9px;
            left: 0;
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #979aa8;
            letter-spacing: 0;
            line-height: 18px;
            font-weight: 400;
          }
          .comment-count {
            position: absolute;
            bottom: 9px;
            right: 0;
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #979aa8;
            letter-spacing: 0;
            line-height: 18px;
            font-weight: 400;
          }
          .show-more {
            cursor: pointer;
            display: flex;
            align-items: center;
            color: #606370;
            font-size: 12px;
            line-height: 1.5;
            position: absolute;
            bottom: 16px;
            left: 50%;
            transform: translateX(-50%);
          }
          .show-more > img {
            width: 14px;
            height: 14px;
            object-fit: cover;
            object-position: center;
          }
          .no-data {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .no-data > span {
            font-size: 14px;
            color: #606370;
            margin-bottom: 8px;
          }
          :global(.community .publish-button) {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 74px;
            height: 28px;
            border-radius: 2px;
            font-size: 14px;
            line-height: 20px;
            color: #1f2129;
            font-weight: normal;
          }

          :global(.publisher-modal) {
            z-index: 1000 !important;
          }

          /*
            注意portal会影响css后代选择器 不可通过设置关系选择器来增加权重 因而直接使用了important
            TODO: 待优化。
           */
          :global(.publisher-modal .modal-body) {
            padding: 0 !important;
            overflow-y: visible !important;
            overflow: visible !important;
          }
          :global(.publisher-modal .modal-container) {
            overflow-y: visible !important;
            overflow: visible !important;
          }
          .publish-icon {
            width: 18px;
            height: 18px;
            object-fit: contain;
            object-position: center;
            margin-right: 4px;
          }
        `}
      </style>
    </div>
  )
}
